export const TYPES_BY_CONSTRUCTION = ['', 'SID', 'TWEEN'];



// WEBPACK FOOTER //
// ./app/constants/vessel.js